module.exports = __webpack_public_path__ + "img/ios-icon.385ace83.png";